export default "__VITE_ASSET__C_BMer9K__"